import React from 'react';
import { Link } from 'react-router-dom';
import { contact, navItems } from '../../data/site';
export function Footer() {
  return <footer className="w-full border-t border-line bg-ink" data-id="element-157" data-mp="eoac1agra4of">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 md:px-10" data-id="element-158" data-mp="alnqfraohfzo">
        <p aria-hidden className="font-serif text-[12vw] leading-[0.95] tracking-[-0.02em] text-paper lg:text-[7.5rem]" data-id="element-159" data-mp="ao06fywvlga3">
          Bas <span className="italic text-amber" data-id="element-160" data-mp="oj2pn16pcgr">Menninga</span>
        </p>

        <div className="mt-14 grid grid-cols-1 gap-10 border-t border-line pt-10 sm:grid-cols-2 lg:grid-cols-12" data-id="element-161" data-mp="pu7nq6d8q9g">
          <div className="lg:col-span-5" data-id="element-162" data-mp="3n3audcq71yyy">
            <p className="max-w-sm text-[15px] leading-relaxed text-sand" data-id="element-163" data-mp="3n4dlnlrfi3fe">
              Singer-songwriter, piano- en gitaardocent uit {contact.location}. Live muziek, muziekles en ukelele-workshops in{' '}
              {contact.region.toLowerCase()}.
            </p>
          </div>
          <nav aria-label="Footer" className="lg:col-span-3" data-id="element-164" data-mp="393jboyoqfuem">
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-165" data-mp="2kd4myu609icb">Menu</p>
            <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2" data-id="element-166" data-mp="2p3te28drwdax">
              {navItems.map(item => <li key={item.to} data-id="element-167" data-mp="2bcoltrcqinam">
                  <Link to={item.to} className="text-[15px] text-sand transition-colors duration-150 hover:text-amber" data-id="element-168" data-mp="2bdhnidwu6mlw">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
          <div className="lg:col-span-3 lg:col-start-10" data-id="element-169" data-mp="33z9ecv4y55fr">
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-170" data-mp="381e5nn7x9pz8">Contact</p>
            <ul className="mt-4 space-y-2 text-[15px]" data-id="element-171" data-mp="2u24pgnjpuvv9">
              <li data-id="element-172" data-mp="2z1r0cqc2o00w">
                <a href={contact.phoneHref} className="text-sand transition-colors duration-150 hover:text-amber" data-id="element-173" data-mp="2z17vobbfn84t">
                  {contact.phone}
                </a>
              </li>
              <li data-id="element-174" data-mp="1nndgrxocq6qo">
                <a href={`mailto:${contact.email}`} className="text-sand transition-colors duration-150 hover:text-amber" data-id="element-175" data-mp="1nnvllip2xta7">
                  {contact.email}
                </a>
              </li>
              <li className="text-muted" data-id="element-176" data-mp="ziw5439gs8e9">{contact.location}, Noord-Holland</li>
            </ul>
          </div>
        </div>

        <p className="mt-12 text-sm text-muted" data-id="element-177" data-mp="uqusuhcaqho8">© {new Date().getFullYear()} Bas Menninga</p>
      </div>
    </footer>;
}